import { useState } from "react";
import { publicApi } from "../hooks/useApi";

export default function Unsubscribe() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || submitting) return;
    setSubmitting(true);
    try {
      await publicApi.post("/leads/unsubscribe", null, { params: { email } });
    } catch {
      // Intentionally silent — always show the neutral confirmation below (no email enumeration)
    } finally {
      setDone(true);
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="unsubscribe-page">
      <h1 className="font-display text-display-sm uppercase mb-3">Unsubscribe</h1>
      {done ? (
        <p data-testid="unsubscribe-success" className="text-sm text-white/75">
          If that address was on The Endure Beyond Dispatch, it has been removed. You won't receive further marketing emails from us.
        </p>
      ) : (
        <>
          <p className="text-sm text-white/75 mb-5">
            Enter the email address you subscribed with to stop receiving The Endure Beyond Dispatch.
          </p>
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
            <input
              data-testid="unsubscribe-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              aria-label="Email address"
              className="flex-1 bg-white/5 border border-white/20 px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-brandAccent placeholder:text-white/40"
            />
            <button
              data-testid="unsubscribe-submit"
              type="submit"
              disabled={submitting}
              className="px-6 py-3 bg-white text-black text-sm uppercase tracking-wide hover:bg-white/80 transition-colors duration-200 disabled:opacity-50"
            >
              {submitting ? "Working…" : "Unsubscribe"}
            </button>
          </form>
        </>
      )}
    </div>
  );
}
